import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateLegalDocumentRequestBody,
  IApiCreateLegalDocumentResponseBody,
} from '../LegalDocumentsApi.types';
import { useApi } from '~/lib/api/useApi';
import { legalDocumentQueryKeyFactory } from './useLegalDocumentQuery';
import { legalDocumentsQueryKeyFactory } from './useLegalDocumentsQuery';

export type IUseCreateLegalDocumentMutationValues = {
  appId: string;
  body: IApiCreateLegalDocumentRequestBody;
};

export const useCreateLegalDocumentMutation = (): UseMutationResult<
  IApiCreateLegalDocumentResponseBody,
  unknown,
  IUseCreateLegalDocumentMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateLegalDocumentMutationValues) =>
      api.legalDocuments.create(values.appId, values.body),
    onSuccess: async (createdLegalDocument) => {
      queryClient.setQueryData(
        legalDocumentQueryKeyFactory({
          appId: createdLegalDocument.appId,
          legalDocumentId: createdLegalDocument._id,
        })!,
        createdLegalDocument,
      );
      await queryClient.invalidateQueries({
        queryKey: legalDocumentsQueryKeyFactory({
          appId: createdLegalDocument.appId,
        }),
      });
    },
  });
};
